"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityChannel = void 0;
const action_1 = require("../../action");
const topic_1 = require("../../topic");
const IDENTITY_CHANNEL = 'identity';
class IdentityChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = IDENTITY_CHANNEL;
        this.topics = {
            loginSuccess: new topic_1.Topic('loginSuccess', IDENTITY_CHANNEL, this._logger),
            logoutSuccess: new topic_1.Topic('logoutSuccess', IDENTITY_CHANNEL, this._logger),
            authenticate: new topic_1.Topic('authenticate', IDENTITY_CHANNEL, this._logger),
            loginFailed: new topic_1.Topic('loginFailed', IDENTITY_CHANNEL, this._logger),
            logout: new topic_1.Topic('logout', IDENTITY_CHANNEL, this._logger),
            preLogoutSuccess: new topic_1.Topic('preLogoutSuccess', IDENTITY_CHANNEL, this._logger),
            userAuthenticationFailed: new topic_1.Topic('userAuthenticationFailed', IDENTITY_CHANNEL, this._logger),
            userAuthenticationSucceeded: new topic_1.Topic('userAuthenticationSucceeded', IDENTITY_CHANNEL, this._logger),
            getToken: new topic_1.Topic('getToken', IDENTITY_CHANNEL, this._logger),
            initThirdParty: new topic_1.Topic('initThirdParty', IDENTITY_CHANNEL, this._logger),
            cleanUserStorage: new action_1.Action('cleanUserStorage', IDENTITY_CHANNEL, this._logger),
            logoutWithRefreshState: new action_1.Action('logoutWithRefreshState', IDENTITY_CHANNEL, this._logger),
            logoutWithoutRefresh: new action_1.Action('logoutWithoutRefresh', IDENTITY_CHANNEL, this._logger),
            doLogout: new action_1.Action('doLogout', IDENTITY_CHANNEL, this._logger)
        };
    }
}
exports.IdentityChannel = IdentityChannel;
//# sourceMappingURL=identity.channel.js.map